import type { ChatMessage } from '../types';

export function isCompactionMessage(m: Pick<ChatMessage, 'role' | 'kind'>): boolean {
  return m.role === 'system' && m.kind === 'compaction';
}
